import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { useTranslations } from 'use-intl';

import useUser from '../../../../hooks/useUser';
import styles from './BrandAndBusinessSelect.module.scss';

const BrandAndBusinessSelect = () => {
  const { businesses, selectedBusiness, setBusiness, disableBusinessSwitch } = useUser();
  const t = useTranslations('common');

  const handleBusinessChange = (event: SelectChangeEvent) => {
    setBusiness(+event.target.value);
  };

  return (
    <FormControl id={styles.brandSelectFormControl} size='small'>
      <InputLabel id='brand'>{t('business')}</InputLabel>
      <Select
        disabled={disableBusinessSwitch}
        labelId='brand'
        label={t('business')}
        value={selectedBusiness?.id?.toString()}
        sx={{ fontSize: 'inherit' }}
        SelectDisplayProps={{ style: { paddingBlock: 7 } }}
        onChange={handleBusinessChange}
      >
        {businesses.map(({ id, name, isActive }) => (
          <MenuItem key={id} value={id} sx={isActive === false ? { color: 'text.disabled' } : undefined}>
            {_.capitalize(name)}
            {isActive === false ? ' — inactive' : ''}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BrandAndBusinessSelect;
